/**
 * Panel definitions for flex/tbSpreads dashboard.
 *
 * Every panel carries a `descriptionKey`. TB spreads is a specialist page — a reader who
 * does not already know that TBn is the sum of the n dearest hours minus the sum of the n
 * cheapest (€/MW per day; from quarter-hour prices since 2025-10-01) cannot tell what the
 * series mean (PI-439). `descriptionKey` is the existing panel-level explanation field,
 * rendered through labelOverrides -> useChartLabels, so this needs no help-system change.
 *
 * Which TBs a chart shows by default, and that its legend starts visible, is catalog config
 * (`visible_by_default` on the series bindings and `legend.visible_by_default`, PI-255),
 * not panel config.
 */
import { applyCountryFilterToPanels } from './countryContext';

const basePanels = [
  {
    id: 'tb-spreads-battery-revenue',
    type: 'datasetChart',
    datasetId: 'epex-tb-spreads',
    visualizationId: 'tb-spreads-battery-revenue',
    labelOverrides: { descriptionKey: 'dashboard_panels.tb_spreads_battery_revenue' },
    gridPos: { x: 0, y: 0, w: 12, h: 17 },
  },
  {
    id: 'tb-spreads-daily-overview',
    type: 'datasetChart',
    datasetId: 'epex-tb-spreads',
    visualizationId: 'tb-spreads-daily-overview',
    labelOverrides: { descriptionKey: 'dashboard_panels.tb_spreads_daily_overview' },
    gridPos: { x: 12, y: 0, w: 12, h: 17 },
  },
  {
    id: 'entsoe-generation-mix-comparison',
    type: 'datasetChart',
    datasetId: 'entsoe-generation',
    visualizationId: 'entsoe-generation-mix-comparison',
    labelOverrides: { descriptionKey: 'dashboard_panels.generation_mix_comparison' },
    gridPos: { x: 0, y: 17, w: 24, h: 11 },
  },
  {
    id: 'tb-spreads-yearly-totals',
    type: 'datasetChart',
    datasetId: 'epex-tb-spreads',
    visualizationId: 'tb-spreads-yearly-totals',
    labelOverrides: { descriptionKey: 'dashboard_panels.tb_spreads_yearly_totals' },
    gridPos: { x: 0, y: 28, w: 24, h: 15 },
  },
  {
    id: 'tb-spreads-daily',
    type: 'datasetChart',
    datasetId: 'epex-tb-spreads',
    visualizationId: 'tb-spreads-daily',
    labelOverrides: { descriptionKey: 'dashboard_panels.tb_spreads_daily' },
    gridPos: { x: 0, y: 43, w: 8, h: 15 },
  },
  {
    id: 'tb-spreads-weekly',
    type: 'datasetChart',
    datasetId: 'epex-tb-spreads',
    visualizationId: 'tb-spreads-weekly',
    labelOverrides: { descriptionKey: 'dashboard_panels.tb_spreads_weekly' },
    gridPos: { x: 8, y: 43, w: 8, h: 15 },
  },
  {
    id: 'tb-spreads-monthly',
    type: 'datasetChart',
    datasetId: 'epex-tb-spreads',
    visualizationId: 'tb-spreads-monthly',
    labelOverrides: { descriptionKey: 'dashboard_panels.tb_spreads_monthly' },
    gridPos: { x: 16, y: 43, w: 8, h: 15 },
  },
  {
    id: 'tb-spreads-period-comparison',
    type: 'datasetChart',
    datasetId: 'epex-tb-spreads',
    visualizationId: 'tb-spreads-period-comparison',
    labelOverrides: { descriptionKey: 'dashboard_panels.tb_spreads_period_comparison' },
    gridPos: { x: 0, y: 58, w: 24, h: 15 },
  },
];

export const flexTbSpreadsPanels = ({ country } = {}) =>
  applyCountryFilterToPanels(basePanels, country);

export const flexTbSpreadsSyncGroups = [];
